import axios from "axios";
import { isCacheable, cacheSet, cacheGet } from "./offline";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "pos_token";

export const api = axios.create({ baseURL: API });

if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (e) => {
    if (e.reason?.isAxiosError && !e.reason.response) e.preventDefault();
  });
}

api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

api.interceptors.response.use(
  (r) => {
    if (isCacheable(r.config)) cacheSet(r.config.url, r.data);
    return r;
  },
  (err) => {
    if (!err.response && isCacheable(err.config)) {
      const cached = cacheGet(err.config.url);
      if (cached !== undefined) return Promise.resolve({ data: cached, status: 200, fromCache: true, config: err.config, headers: {} });
    }
    if (err.response?.status === 401 && !err.config.url.includes("/auth/login")) {
      localStorage.removeItem(TOKEN_KEY);
      if (window.location.pathname !== "/login") window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

export function errMsg(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Terjadi kesalahan, coba lagi.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
}
